export enum StartingCondition {
    Cold,
    Warm
}
